module.exports = __webpack_public_path__ + "bf8d55ce1be11bc1f6363d4a115aa4b3.svg";